var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBrandGoogle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#DA5140",
  d: "M22 12.239c0 5.83-3.971 9.98-9.836 9.98C6.54 22.218 2 17.652 2 12S6.541 1.782 12.164 1.782c2.738 0 5.04 1.01 6.816 2.674L16.213 7.13C12.594 3.62 5.865 6.256 5.865 12c0 3.564 2.832 6.452 6.299 6.452 4.025 0 5.533-2.9 5.77-4.404h-5.77v-3.515h9.676A9 9 0 0 1 22 12.24"
})));
export default SvgBrandGoogle;